import config from "../../config";

const LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error']
const logLevel = LOG_LEVELS.indexOf(config.logLevel) ?? LOG_LEVELS.indexOf(config.logLevel ?? 'error')

function _log(level: string, ...msg: unknown[]) {
    if (logLevel > LOG_LEVELS.indexOf(level)) return
    switch (level) {
        case 'error':
            console.error(...msg);
            break;
        case 'warn':
            console.warn(...msg);
            break;
        case 'info':
            console.info(...msg);
            break;
        default:
            console.log(...msg);
            break;
    }

}

_log('info', `Logger initialized with "${LOG_LEVELS[logLevel]}" level`)

interface Logger {
    trace(...msg: unknown[]): void
    debug(...msg: unknown[]): void
    info(...msg: unknown[]): void
    warn(...msg: unknown[]): void
    error(...msg: unknown[]): void
}

export const log: Logger = {
    /**
     * Log that trace what part of the code is being executed
    */
    trace: (...msg: unknown[]) => _log('trace', ...msg),
    /**
     * Log that provide informations only usefull to developpers for debugging purpose
     */
    debug: (...msg: unknown[]) => _log('debug', ...msg),
    /**
     * Log that provide generally usefull informations :
     * - Services created / destroyed
     * - Configuration assumptions
     * ...
     */
    info: (...msg: unknown[]) => _log('info', ...msg),
    /**
     * Log things that went wrong without crashing the application
     */
    warn: (...msg: unknown[]) => _log('warn', ...msg),
    /**
     * Log things that make the application unable to run correctly
     */
    error: (...msg: unknown[]) => _log('error', ...msg)
}
